import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

import { createNotification } from '#src/store/notifications/actions';

const query = gql`
  mutation RemoveOrderItem($orderId: PositiveInt!, $itemId: PositiveInt!) {
    removeOrderItemV2(orderId: $orderId, itemId: $itemId) {
      id
      amountDue
      orderItems {
        id
        type
        amount
        promo {
          id
          code
        }
        game {
          id
        }
      }
    }
  }
`;

export function useRemoveItem({ orderId }) {
  const [mutate] = useMutation(query);

  async function removeItem(itemId) {
    try {
      return await mutate({
        variables: {
          orderId,
          itemId,
        },
      });
    } catch (error) {
      createNotification({ message: error.message });
    }
  }

  return { removeItem };
}
